import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

// AUTH
import AuthLogin from "./Auth/login";
// SYSTEM
import DashboardPage from "./Dashboard";
// BILETS
import BiletsList from "./Bilets/list";
import BiletsOne from "./Bilets/one";
import BiletsEdit from "./Bilets/edit";
import BiletsEditHistory from "./Bilets/editHistory";
// BLANKS
import BlanksList from "./Blanks/list";
import BlanksOne from "./Blanks/one";
import BlanksEdit from "./Blanks/edit";
// DEPOSITORS
import DepositorsList from "./Depositors/list";
import DepositorsOne from "./Depositors/one";
import DepositorsEdit from "./Depositors/edit";
// FILIALS
import FilialsList from "./Filials/list";
import FilialsOne from "./Filials/one";
import FilialsEdit from "./Filials/edit";
import FilialsEditPercents from "./Filials/components/percentsEdit";
import FilialsEditPrices from "./Filials/components/pricesEdit";
import FilialsEditMoney from "./Filials/editMoney";
// USERS
import UsersList from "./Users/list";
import UsersOne from "./Users/one";
import UsersEdit from "./Users/edit";
// REPORTS
import ReportMonth from "./Reports/month";
import ReportDayOne from "./Reports/day";
import ReportDayEdit from "./Reports/edit";
// SETTINGS
import SettingsIndexPage from "./Settings/index";
import SettingsAccountView from "./Settings/Account/view";
import SettingsAccountEdit from "./Settings/Account/edit";
import SettingsTemplatesList from "./Settings/Templates/list";
import SettingsTemplatesOne from "./Settings/Templates/one";
import SettingsMarker from "./Settings/Markers";
import SettingsCalcGesv from "./Settings/Calc/gesv";
// Public
import PublicReports from "./Public/Reports";
// Not found
import NotFound from "./NotFound";

class Router extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={AuthLogin} />

        <Route exact path="/dashboard" component={DashboardPage} />

        <Route exact path="/bilets" component={BiletsList} />
        <Route exact path="/bilets/:id" component={BiletsOne} />
        <Route exact path="/bilets/:id/edit" component={BiletsEdit} />
        <Route
          exact
          path="/bilets/:id/edit/history/:historyId"
          component={BiletsEditHistory}
        />

        <Route exact path="/blanks" component={BlanksList} />
        <Route exact path="/blanks/:id" component={BlanksOne} />
        <Route exact path="/blanks/:id/edit" component={BlanksEdit} />

        <Route exact path="/depositors" component={DepositorsList} />
        <Route exact path="/depositors/:id" component={DepositorsOne} />
        <Route exact path="/depositors/:id/edit" component={DepositorsEdit} />

        <Route exact path="/filials" component={FilialsList} />
        <Route exact path="/filials/create" component={FilialsEdit} />
        <Route exact path="/filials/:id" component={FilialsOne} />
        <Route exact path="/filials/:id/edit" component={FilialsEdit} />
        <Route
          exact
          path="/filials/:id/percents/edit"
          component={FilialsEditPercents}
        />
        <Route
          exact
          path="/filials/:id/prices/edit"
          component={FilialsEditPrices}
        />
        <Route
          exact
          path="/filials/:id/money/:moneyId/edit"
          component={FilialsEditMoney}
        />

        <Route exact path="/users" component={UsersList} />
        <Route exact path="/users/create" component={UsersEdit} />
        <Route exact path="/users/:id" component={UsersOne} />
        <Route exact path="/users/:id/edit" component={UsersEdit} />

        <Route exact path="/reports/month" component={ReportMonth} />
        <Route exact path="/reports/day" component={ReportDayOne} />
        <Route exact path="/reports/day/:id/edit" component={ReportDayEdit} />

        <Route exact path="/settings" component={SettingsIndexPage} />
        <Route exact path="/settings/account" component={SettingsAccountView} />
        <Route
          exact
          path="/settings/account/edit"
          component={SettingsAccountEdit}
        />
        <Route
          exact
          path="/settings/templates"
          component={SettingsTemplatesList}
        />
        <Route
          exact
          path="/settings/templates/:id"
          component={SettingsTemplatesOne}
        />
        <Route exact path="/settings/markers" component={SettingsMarker} />
        <Route exact path="/settings/calc/gesv" component={SettingsCalcGesv} />

        <Route exact path="/public/reports" component={PublicReports} />

        <Route component={NotFound} />
      </Switch>
    );
  }
}

export default Router;
